interface QualityProps {
  onViewCert: () => void;
}

export default function Quality({ onViewCert }: QualityProps) {
  const certifications = [
    {
      icon: 'ri-shield-check-line',
      title: '수질검사',
      items: ['일반세균 불검출', '대장균군 불검출', 'pH 7.2 (적정)', '질산성질소 2.1mg/L'],
      date: '2024.11.15'
    },
    {
      icon: 'ri-flask-line',
      title: '잔류농약 검사',
      items: ['검사항목 320종', '전 항목 불검출', '한국식품안전연구원'],
      date: '2024.10.28'
    },
    {
      icon: 'ri-microscope-line',
      title: '미생물 검사',
      items: ['대장균 음성', '살모넬라 음성', '황색포도상구균 음성', '리스테리아 음성'],
      date: '2024.11.20'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            검사 성적서 전면 공개
          </h2>
          <p className="text-lg text-gray-600">
            정기적인 검사를 통해 안전성을 확인하고, 모든 결과를 투명하게 공개합니다.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {certifications.map((cert, index) => (
            <div 
              key={index}
              className="bg-[#FDFBF7] rounded-xl p-8 border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#6B4E9C]/10 rounded-full mb-6">
                <i className={`${cert.icon} text-3xl text-[#6B4E9C]`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {cert.title}
              </h3>
              
              <ul className="space-y-2 mb-6">
                {cert.items.map((item, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-gray-600">
                    <i className="ri-check-line text-[#6B4E9C] mt-1 flex-shrink-0"></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
              
              <div className="text-sm text-gray-500 pt-4 border-t border-gray-200">
                검사일: {cert.date}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button 
            onClick={onViewCert}
            className="inline-flex items-center gap-3 bg-[#6B4E9C] text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-[#5A3D8B] transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-text-line text-xl"></i>
            전체 검사성적서 보기
          </button>
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-[#6B4E9C]/5 to-purple-100/30 rounded-xl p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                <i className="ri-award-line text-2xl text-[#6B4E9C]"></i>
              </div>
              <div>
                <h4 className="font-bold text-lg text-gray-900 mb-2">무농약 인증</h4>
                <p className="text-gray-600 mb-3">
                  국립농산물품질관리원 무농약 인증을 받은 포도만 사용합니다.
                </p>
                <p className="text-sm text-gray-500">
                  인증번호: 제2024-XXX-XXXX호 (유효기간: 2025.12.31)
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#6B4E9C]/5 to-purple-100/30 rounded-xl p-8">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full flex-shrink-0">
                <i className="ri-recycle-line text-2xl text-[#6B4E9C]"></i>
              </div>
              <div>
                <h4 className="font-bold text-lg text-gray-900 mb-2">유기질 퇴비 재배</h4>
                <p className="text-gray-600 mb-3">
                  화학비료를 사용하지 않고 자연 유기질 퇴비로만 재배합니다.
                </p>
                <p className="text-sm text-gray-500">
                  재배 이력 추적 시스템 운영 중
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}